import { useEffect, useState } from 'react';

import { setGMapsError } from 'modules/main/store/ducks/gMapsError';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { useMainSelector } from 'modules/main/store/hooks/useMainSelector';
import { loadGoogleMaps } from 'utils/address/loadGoogleMaps';

export function useLoadGoogleMapsAutocomplete() {
  const gMapsErrored = useMainSelector((state) => state.gMapsError.errored);

  const [autocompleteService, setAutocompleteService] =
    useState<google.maps.places.AutocompleteService>();
  const [geocoder, setGeocoder] = useState<google.maps.Geocoder>();
  const [sessionToken, setSessionToken] =
    useState<google.maps.places.AutocompleteSessionToken>();

  const dispatch = useMainDispatch();

  useEffect(() => {
    if (autocompleteService) return;

    loadGoogleMaps()
      .then((maps) => {
        setAutocompleteService(new maps.places.AutocompleteService());
        setGeocoder(new maps.Geocoder());
        setSessionToken(new maps.places.AutocompleteSessionToken());
      })
      .catch((error) => {
        dispatch(setGMapsError(error.message));
      });
  }, [autocompleteService, dispatch]);

  return { geocoder, gMapsErrored, autocompleteService, sessionToken };
}
